webpackJsonp([231608221292675],{

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(132),
	  options: { "plugins": [] }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   {
	//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
	//     options: { ... },
	//   },
	//   {
	//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
	//     options: { ... },
	//   },
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== "undefined";
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-layouts-post-js": __webpack_require__(237),
	  "component---src-pages-404-js": __webpack_require__(238),
	  "component---src-pages-about-js": __webpack_require__(239),
	  "component---src-pages-blog-js": __webpack_require__(240),
	  "component---src-pages-contact-js": __webpack_require__(241),
	  "component---src-pages-index-js": __webpack_require__(242),
	  "component---src-pages-projects-js": __webpack_require__(243),
	  "component---src-pages-projects-stronglist-index-js": __webpack_require__(244),
	  "component---src-pages-projects-stronglist-privacy-js": __webpack_require__(245),
	  "component---src-pages-projects-stronglist-support-js": __webpack_require__(246),
	  "component---src-pages-projects-verifiable-bookmarklets-js": __webpack_require__(247),
	  "component---src-pages-thanks-js": __webpack_require__(248),
	  "component---src-pages-uses-js": __webpack_require__(249)
	};
	
	exports.json = {
	  "layout-index.json": __webpack_require__(250),
	  "blog-hola.json": __webpack_require__(262),
	  "blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity.json": __webpack_require__(276),
	  "blog-i-dont-need-you-itunes.json": __webpack_require__(264),
	  "blog-the-passionate-programmer.json": __webpack_require__(277),
	  "blog-servicios-abiertos-o-cerrados-i-last-fm.json": __webpack_require__(275),
	  "blog-i-prefer-githubpages-to-wordpresscom.json": __webpack_require__(265),
	  "blog-were-like-wine-we-get-better-with-time.json": __webpack_require__(280),
	  "blog-guide-to-online-sustainability.json": __webpack_require__(260),
	  "blog-barcampes-sevilla-2012.json": __webpack_require__(255),
	  "blog-is-there-cooperation-between-coworkers.json": __webpack_require__(266),
	  "blog-rise-against-procrastination.json": __webpack_require__(274),
	  "blog-let-me-introduce-you-to-audiostation-steroids.json": __webpack_require__(267),
	  "blog-feeling-good-out-of-my-comfort-zone.json": __webpack_require__(257),
	  "blog-getting-started-with-wordpress-in-openshift.json": __webpack_require__(258),
	  "blog-going-back-to-the-roots-to-evolve.json": __webpack_require__(259),
	  "blog-moving-this-site-to-gatsby.json": __webpack_require__(268),
	  "blog-resolving-our-coworking-network.json": __webpack_require__(273),
	  "blog-reflections-about-mid-2018-java-script-state.json": __webpack_require__(272),
	  "blog-next-steps-after-level-2-react-native-with-graphql-part-1.json": __webpack_require__(269),
	  "blog-what-you-need-to-successfully-work-remotely.json": __webpack_require__(281),
	  "blog-rebooting-this-website.json": __webpack_require__(271),
	  "blog-don-t-fear-the-hoc-when-writing-react.json": __webpack_require__(256),
	  "blog-o-auth-2-with-react-native-keeping-expo.json": __webpack_require__(270),
	  "blog-here-my-uses-page.json": __webpack_require__(261),
	  "blog-writing-scripts-as-frontend-with-es-6-and-jest.json": __webpack_require__(282),
	  "blog-uses-2026-update.json": __webpack_require__(278),
	  "blog-verifiable-bookmarklets.json": __webpack_require__(279),
	  "blog-i-dont-need-an-integration-for-everything.json": __webpack_require__(263),
	  "404.json": __webpack_require__(251),
	  "about.json": __webpack_require__(253),
	  "blog.json": __webpack_require__(254),
	  "contact.json": __webpack_require__(283),
	  "index.json": __webpack_require__(284),
	  "projects.json": __webpack_require__(285),
	  "projects-stronglist.json": __webpack_require__(286),
	  "projects-stronglist-privacy.json": __webpack_require__(287),
	  "projects-stronglist-support.json": __webpack_require__(288),
	  "projects-verifiable-bookmarklets.json": __webpack_require__(289),
	  "thanks.json": __webpack_require__(290),
	  "uses.json": __webpack_require__(291),
	  "404-html.json": __webpack_require__(252)
	};
	
	exports.layouts = {
	  "layout---index": __webpack_require__(236)
	};

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(88);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(39);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(54);
	
	var _shallowCompare = __webpack_require__(376);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // Set the pathname for 404 pages.
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, {
	        pathname: "/404.html"
	      });
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        var location = nextProps.location;
	
	        // Set the pathname for 404 pages.
	        if (!_loader2.default.getPage(location.pathname)) {
	          location = _extends({}, location, {
	            pathname: "/404.html"
	          });
	        }
	
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(location.pathname, function (pageResources) {
	          _this2.setState({
	            location: location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return (0, _shallowCompare2.default)(this, nextProps, nextState);
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(343);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(53);
	
	var _stripPrefix = __webpack_require__(89);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO add tests especially for handling prefixed links.
	var pageCache = {};
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = (0, _stripPrefix2.default)(pathname, pathPrefix);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(297);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(300) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(301) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(273950069227526, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(302) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(5526846739417, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(303) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(197763655224487, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(304) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(62150283453470, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(305) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(262186115260319, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(306) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(116614762260705, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(307) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(187588416059902, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(308) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162071184656010, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(309) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(188609235178654, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(310) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(223791756368807, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(311) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(120707092105182, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(312) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(28955749356104, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(313) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(51892261670996, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(314) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(281111594674807, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(315) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(129801922668262, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(316) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(116798976540311, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(317) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(138776141577327, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(318) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(279979968178579, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(319) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(194809101423960, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(320) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(226314456991004, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(321) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(252397932232587, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(322) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(181134748120480, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(323) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(83007410558793, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(324) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(99687412801325, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(325) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(88152412520283, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(326) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(73603943949020, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(327) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(210326852267240, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(328) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(129148645212334, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(329) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(214567633979398, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(330) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(49683490770531, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(331) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(184662623972074, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(332) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(333) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(81) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(191006563875610, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(334) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(98767858357558, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(335) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(44111250808295, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(336) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(28033720072838, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(337) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(97786326051841, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(338) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(229114350069216, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(339) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(111194303327527, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(340) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(114276838955818, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(129) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(127);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(39);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _stripPrefix = __webpack_require__(89);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var pathPrefix = "";
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	var fetchHistory = [];
	var failedPaths = {};
	var failedResources = {};
	var MAX_HISTORY = 5;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(130)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = void 0;
	    if (resourceName.slice(0, 12) === "component---") {
	      resourceFunction = asyncRequires.components[resourceName];
	    } else if (resourceName.slice(0, 9) === "layout---") {
	      resourceFunction = asyncRequires.layouts[resourceName];
	    } else {
	      resourceFunction = asyncRequires.json[resourceName];
	    }
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      fetchHistory.push({
	        resource: resourceName,
	        succeeded: !err
	      });
	
	      if (!failedResources[resourceName]) {
	        failedResources[resourceName] = err;
	      }
	
	      fetchHistory = fetchHistory.slice(-MAX_HISTORY);
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else if (failedResources[resourceName]) {
	    process.nextTick(function () {
	      cb(failedResources[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var appearsOnLine = function appearsOnLine() {
	  var isOnLine = navigator.onLine;
	  if (typeof isOnLine === "boolean") {
	    return isOnLine;
	  }
	
	  // If no navigator.onLine support assume onLine if any of last N fetches succeeded
	  var succeededFetch = fetchHistory.find(function (entry) {
	    return entry.succeeded;
	  });
	  return !!succeededFetch;
	};
	
	var handleResourceLoadError = function handleResourceLoadError(path, message) {
	  console.log(message);
	
	  if (!failedPaths[path]) {
	    failedPaths[path] = message;
	  }
	
	  if (appearsOnLine() && window.location.pathname.replace(/\/$/g, "") !== path.replace(/\/$/g, "")) {
	    window.location.pathname = path;
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	    pathPrefix = "";
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    if (true) {
	      if (false) pathPrefix = __PATH_PREFIX__;
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue() {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(rawPath) {
	    // Check page exists.
	    var path = (0, _stripPrefix2.default)(rawPath, pathPrefix);
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layout],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      if (failedPaths[path]) {
	        handleResourceLoadError(path, "Previously detected load failure for \"" + path + "\"");
	
	        return cb();
	      }
	
	      var _page = findPage(path);
	
	      if (!_page) {
	        handleResourceLoadError(path, "A page wasn't found for \"" + path + "\"");
	
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layout, function (err, l) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)))

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-hola.json","path":"/blog/hola"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity.json","path":"/blog/servicios-abiertos-o-cerrados-ii-imdb-y-filmaffinity"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-i-dont-need-you-itunes.json","path":"/blog/i-dont-need-you-itunes"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-the-passionate-programmer.json","path":"/blog/the-passionate-programmer"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-servicios-abiertos-o-cerrados-i-last-fm.json","path":"/blog/servicios-abiertos-o-cerrados-i-last-fm"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-i-prefer-githubpages-to-wordpresscom.json","path":"/blog/i-prefer-githubpages-to-wordpresscom"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-were-like-wine-we-get-better-with-time.json","path":"/blog/were-like-wine-we-get-better-with-time"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-guide-to-online-sustainability.json","path":"/blog/guide-to-online-sustainability"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-barcampes-sevilla-2012.json","path":"/blog/barcampes-sevilla-2012"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-is-there-cooperation-between-coworkers.json","path":"/blog/is-there-cooperation-between-coworkers"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-rise-against-procrastination.json","path":"/blog/rise-against-procrastination"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-let-me-introduce-you-to-audiostation-steroids.json","path":"/blog/let-me-introduce-you-to-audiostation-steroids"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-feeling-good-out-of-my-comfort-zone.json","path":"/blog/feeling-good-out-of-my-comfort-zone"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-getting-started-with-wordpress-in-openshift.json","path":"/blog/getting-started-with-wordpress-in-openshift"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-going-back-to-the-roots-to-evolve.json","path":"/blog/going-back-to-the-roots-to-evolve"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-moving-this-site-to-gatsby.json","path":"/blog/moving-this-site-to-gatsby"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-resolving-our-coworking-network.json","path":"/blog/resolving-our-coworking-network"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-reflections-about-mid-2018-java-script-state.json","path":"/blog/reflections-about-mid-2018-java-script-state"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-next-steps-after-level-2-react-native-with-graphql-part-1.json","path":"/blog/next-steps-after-level-2-react-native-with-graphql-part1"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-what-you-need-to-successfully-work-remotely.json","path":"/blog/what-you-need-to-successfully-work-remotely"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-rebooting-this-website.json","path":"/blog/rebooting-this-website"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-don-t-fear-the-hoc-when-writing-react.json","path":"/blog/don-t-fear-the-hoc-when-writing-react"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-o-auth-2-with-react-native-keeping-expo.json","path":"/blog/o-auth-2-with-react-native-keeping-expo"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-here-my-uses-page.json","path":"/blog/here-my-uses-page"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-writing-scripts-as-frontend-with-es-6-and-jest.json","path":"/blog/writing-scripts-as-frontend-with-es6-and-jest"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-uses-2026-update.json","path":"/blog/uses-2026-update"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-verifiable-bookmarklets.json","path":"/blog/verifiable-bookmarklets"},{"componentChunkName":"component---src-layouts-post-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog-i-dont-need-an-integration-for-everything.json","path":"/blog/i-dont-need-an-integration-for-everything"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404.json","path":"/404/"},{"componentChunkName":"component---src-pages-about-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"about.json","path":"/about/"},{"componentChunkName":"component---src-pages-blog-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"blog.json","path":"/blog/"},{"componentChunkName":"component---src-pages-contact-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"contact.json","path":"/contact/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-projects-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projects.json","path":"/projects/"},{"componentChunkName":"component---src-pages-projects-stronglist-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projects-stronglist.json","path":"/projects/stronglist/"},{"componentChunkName":"component---src-pages-projects-stronglist-privacy-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projects-stronglist-privacy.json","path":"/projects/stronglist/privacy/"},{"componentChunkName":"component---src-pages-projects-stronglist-support-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projects-stronglist-support.json","path":"/projects/stronglist/support/"},{"componentChunkName":"component---src-pages-projects-verifiable-bookmarklets-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"projects-verifiable-bookmarklets.json","path":"/projects/verifiable-bookmarklets/"},{"componentChunkName":"component---src-pages-thanks-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"thanks.json","path":"/thanks/"},{"componentChunkName":"component---src-pages-uses-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"uses.json","path":"/uses/"},{"componentChunkName":"component---src-pages-404-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"404-html.json","path":"/404.html"}]

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(54);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(115);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(53);
	
	var _gatsbyReactRouterScroll = __webpack_require__(295);
	
	var _domready = __webpack_require__(231);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(11);
	
	var _history2 = __webpack_require__(128);
	
	var _history3 = _interopRequireDefault(_history2);
	
	var _emitter = __webpack_require__(39);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(341);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(342);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(126);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(125);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(88);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(156);
	}
	
	window.___history = _history3.default;
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history3.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(131);
	  }
	
	  var navigate = function navigate(to, replace) {
	    var location = (0, _history.createLocation)(to, null, null, _history3.default.location);
	    var pathname = location.pathname;
	
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	    var wl = window.location;
	
	    // If we're already at this location, do nothing.
	    if (wl.pathname === location.pathname && wl.search === location.search && wl.hash === location.hash) {
	      return;
	    }
	
	    var historyNavigateFunc = replace ? window.___history.replace : window.___history.push;
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        historyNavigateFunc(location);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      historyNavigateFunc(location);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      historyNavigateFunc(location);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___push = function (to) {
	    return navigate(to, false);
	  };
	  window.___replace = function (to) {
	    return navigate(to, true);
	  };
	  window.___navigateTo = window.___push;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history3.default.location,
	    action: _history3.default.action
	  });
	
	  var initialAttachDone = false;
	  function attachToHistory(history) {
	    if (!window.___history || initialAttachDone === false) {
	      window.___history = history;
	      initialAttachDone = true;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          // Make sure React has had a chance to flush to DOM first.
	          setTimeout(function () {
	            (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	          }, 0);
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history3.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history3.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	
	    var renderer = (0, _apiRunnerBrowser.apiRunner)("replaceHydrateFunction", undefined, _reactDom2.default.render)[0];
	
	    (0, _domready2.default)(function () {
	      return renderer(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(39);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	/**
	 * Remove a prefix from a string. Return the input string if the given prefix
	 * isn't found.
	 */
	
	exports.default = function (str) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	  if (str.substr(0, prefix.length) === prefix) return str.slice(prefix.length);
	  return str;
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// Send a GA4 page_view on client-side route changes.
	//
	// gtag('config') in gatsby-ssr.js already sends the page_view for the
	// initial page load, so the first onRouteUpdate call is skipped.
	// react-helmet updates document.title in a requestAnimationFrame callback,
	// so the event waits two frames to make sure page_title is the new one.
	
	var isInitialLoad = true;
	
	var sendPageView = function sendPageView(location) {
	  if (typeof window.gtag !== 'function') return;
	
	  window.gtag('event', 'page_view', {
	    page_location: window.location.href,
	    page_path: '' + location.pathname + location.search + location.hash,
	    page_title: document.title
	  });
	};
	
	var onRouteUpdate = exports.onRouteUpdate = function onRouteUpdate(_ref) {
	  var location = _ref.location;
	
	  if (false) return;
	
	  // Gatsby 1 does not pass prevLocation, so track the first call here.
	  if (isInitialLoad) {
	    isInitialLoad = false;
	    return;
	  }
	
	  if ('requestAnimationFrame' in window) {
	    requestAnimationFrame(function () {
	      requestAnimationFrame(function () {
	        return setTimeout(function () {
	          return sendPageView(location);
	        }, 0);
	      });
	    });
	  } else {
	    // Matches the delay used by gatsby-plugin-google-gtag.
	    setTimeout(function () {
	      return sendPageView(location);
	    }, 32);
	  }
	};

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(c,e){(n[c]||(n[c]=[])).push(e)},off:function(c,e){n[c]&&n[c].splice(n[c].indexOf(e)>>>0,1)},emit:function(c,e){(n[c]||[]).slice().map(function(n){n(e)}),(n["*"]||[]).slice().map(function(n){n(c,e)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(372);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Pulled from react-compat
	// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
	function shallowDiffers(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }return false;
	}
	
	exports.default = function (instance, nextProps, nextState) {
	  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(77196258398326, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(136) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(162898551421021, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(137) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(263791100135453, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(138) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(212839066777427, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(139) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(70144966829960, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(140) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(35783957827783, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(141) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(213720915766396, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(142) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(212420072151734, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(143) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(270710348363565, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(144) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(53429247197209, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(145) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(126236933479302, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(146) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(253626871324061, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(147) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      1
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(173384378255071, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(148) })
	        }
	      });
	     }
	    

/***/ })

});


// WEBPACK FOOTER //
// app-7179882a571cfbf03a1e.js